import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "formgrid grid" }
const _hoisted_3 = { class: "field col-12 md:col-6 sm:col-6 lg:col-1" }
const _hoisted_4 = { for: "date" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "p-error"
}
const _hoisted_7 = { class: "field col-12 md:col-6 sm:col-6 lg:col-1" }
const _hoisted_8 = { for: "fromTime" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "p-error"
}
const _hoisted_11 = { class: "field col-12 md:col-6 sm:col-6 lg:col-1" }
const _hoisted_12 = { for: "toTime" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "p-error"
}
const _hoisted_15 = { class: "field col-12 md:col-6 sm:col-6 lg:col-2" }
const _hoisted_16 = { for: "toTime" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 0,
  class: "p-error"
}
const _hoisted_19 = { class: "field col-12 md:col-2 sm:col-2 lg:col-1" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", null, " ", -1)

import Button from 'primevue/button'
import Calendar from 'primevue/calendar'
import InputNumber from 'primevue/inputnumber'
import Message from 'primevue/message'
import Panel from 'primevue/panel'

import {AxiosStatic} from "axios";
import {inject, onMounted, reactive, ref} from "vue";
import useVuelidate from "@vuelidate/core";
import InputField from "@/components/blocks/InputField.vue";
import ProjectField from "@/components/blocks/ProjectField.vue";

// Define types
import {FormDataType, TimelineRules} from "@/components/blocks/TimelineDefs";
import moment from "moment";

// Define component data

export default /*#__PURE__*/_defineComponent({
  __name: 'CreateTimelineForm',
  emits: ['itemCreated'],
  setup(__props, { emit: emits }) {

const formData = reactive<FormDataType>({
  id: null,
  project: null,
  date: new Date(),
  fromTime: null,
  toTime: null,
  note: null,
  pause: 30
})

const submitted = ref<boolean>(false)
const errorMessage = ref<string | null>(null)

// Inject dependencies
const axios = inject<AxiosStatic>('axios')

// Define used properties
const v$ = useVuelidate(TimelineRules, formData)

// Define emits


// Define lifecycle hooks
onMounted(() => {
  const fromTime = new Date()
  fromTime.setHours(6, 30)
  formData.fromTime = fromTime

  const toTime = new Date()
  toTime.setHours(15, 30)
  formData.toTime = toTime
})

// Define functions
function handleSubmit(isFormValid: boolean) {
  submitted.value = true
  if (isFormValid) {
    saveTimeline()
  } else {
    console.error('Form is not valid!')
  }
}

function saveTimeline() {
  const path = "/timeline"
  errorMessage.value = null
  axios?.post(path, buildData()).then((response) => {
    if (response.status >= 200 && response.status <= 299) {
      if (response.data.itemID > 0) {
        emits('itemCreated', response.data)
        submitted.value = false
        clearFormData()


      } else {

        if (response.data.success == false) {
          // this is custom error response with any business error
          errorMessage.value = response.data.list[0].message
        }

        console.error("Can not save timeline. Invalid response", response)
      }
    } else {
      // message.error('Ulozeni spolecnosti se nezdarilo!')
      console.error(response)
    }
  })
}

function clearFormData() {
  formData.fromTime = formData.toTime
  if (formData.pause > 0) {
    formData.pause = 0
  }
  formData.toTime = null
  formData.note = null
}

function buildData(): any {

  const input = formData.date?.getFullYear() + "-" + (1 + (formData.date?.getMonth() || 0)).toString(10).padStart(2, '0') + "-" +
      formData.date?.getDate().toString(10).padStart(2, '0')

  const fromTimeM = moment(input, 'YYYY-MM-DD')

  fromTimeM.set('hour', (formData.fromTime as Date).getHours())
  fromTimeM.set('minute', (formData.fromTime as Date).getMinutes())
  const fromTruncated = fromTimeM.startOf('minute').toISOString(true)

  const toTimeM = moment(input, 'YYYY-MM-DD')
  toTimeM.set('hour', (formData.toTime as Date).getHours())
  toTimeM.set('minute', (formData.toTime as Date).getMinutes())
  const toTimeTruncated = toTimeM.startOf('minute').toISOString(true)

  const x = {
    projectId: formData.project.id,
    fromTime: fromTruncated,
    toTime: toTimeTruncated,
    pause: formData.pause,
    workTime: 0,
    note: formData.note
  }
  return x
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Panel), { class: "mt-2 mb-2" }, {
    default: _withCtx(() => [
      (errorMessage.value!=null)
        ? (_openBlock(), _createBlock(_unref(Message), {
            key: 0,
            severity: "error",
            closable: false
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(errorMessage.value), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (handleSubmit(!_unref(v$).$invalid)), ["prevent"])),
        class: "p-fluid"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("label", _hoisted_4, [
                _createTextVNode(_toDisplayString(_ctx.$t('date')) + " ", 1),
                (_unref(v$).date.required)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "*"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_unref(Calendar), {
                id: "date",
                dateFormat: "dd.mm.yy",
                class: _normalizeClass({'p-invalid':_unref(v$).date.$invalid && submitted.value}),
                modelValue: _unref(v$).date.$model,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).date.$model) = $event))
              }, null, 8, ["class", "modelValue"]),
              (_unref(v$).date.$invalid && submitted.value)
                ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_unref(v$).date.required.$message.replace('Value', 'Date')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, [
                _createTextVNode(_toDisplayString(_ctx.$t('from-time')) + " ", 1),
                (_unref(v$).fromTime.required)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, "*"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_unref(Calendar), {
                id: "fromTime",
                dateFormat: "HH:MM",
                class: _normalizeClass({'p-invalid':_unref(v$).fromTime.$invalid && submitted.value}),
                timeOnly: true,
                hourFormat: "24",
                stepMinute: 15,
                modelValue: _unref(v$).fromTime.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).fromTime.$model) = $event))
              }, null, 8, ["class", "modelValue"]),
              (_unref(v$).fromTime.$invalid && submitted.value)
                ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(_unref(v$).fromTime.required.$message.replace('Value', 'Time from')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, [
                _createTextVNode(_toDisplayString(_ctx.$t('to-time')) + " ", 1),
                (_unref(v$).toTime.required)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, "*"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_unref(Calendar), {
                id: "toTime",
                dateFormat: "HH:MM",
                class: _normalizeClass({'p-invalid':_unref(v$).toTime.$invalid && submitted.value}),
                timeOnly: true,
                hourFormat: "24",
                stepMinute: 15,
                modelValue: _unref(v$).toTime.$model,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).toTime.$model) = $event))
              }, null, 8, ["class", "modelValue"]),
              (_unref(v$).toTime.$invalid && submitted.value)
                ? (_openBlock(), _createElementBlock("small", _hoisted_14, _toDisplayString(_unref(v$).toTime.required.$message.replace('Value', 'Time to')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("label", _hoisted_16, [
                _createTextVNode(_toDisplayString(_ctx.$t('pause')) + " ", 1),
                (_unref(v$).toTime.required)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, "*"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_unref(InputNumber), {
                modelValue: _unref(v$).pause.$model,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).pause.$model) = $event)),
                id: "pause",
                min: 0,
                step: 15,
                allowEmpty: false,
                showButtons: "",
                buttonLayout: "horizontal",
                decrementButtonClass: "p-button-danger",
                incrementButtonClass: "p-button-success",
                incrementButtonIcon: "pi pi-plus",
                decrementButtonIcon: "pi pi-minus",
                suffix: " min",
                mode: "decimal"
              }, null, 8, ["modelValue"]),
              (_unref(v$).toTime.$invalid && submitted.value)
                ? (_openBlock(), _createElementBlock("small", _hoisted_18, _toDisplayString(_unref(v$).toTime.required.$message.replace('Value', 'Pause')), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode(ProjectField, {
              class: "col-12 md:col-6 sm:col-6 lg:col-2",
              id: "project",
              label: _ctx.$t('project'),
              modelValue: formData.project,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.project) = $event)),
              vualidate: _unref(v$).project,
              submitted: submitted.value
            }, null, 8, ["label", "modelValue", "vualidate", "submitted"]),
            _createVNode(InputField, {
              id: "note",
              class: "field col-12 md:col-10 sm:col-10 lg:col-4",
              label: _ctx.$t('note'),
              vualidate: _unref(v$).note,
              submitted: submitted.value,
              modelValue: formData.note,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.note) = $event))
            }, null, 8, ["label", "vualidate", "submitted", "modelValue"]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_unref(Button), {
                type: "submit",
                label: _ctx.$t('add')
              }, null, 8, ["label"])
            ])
          ])
        ])
      ], 32)
    ]),
    _: 1
  }))
}
}

})